<template>
<div>
  <div v-if="!user.loggedIn">
    <fieldset class="border-bottom form-group mb-4">
      <legend><h2>Login to EZSalt</h2></legend>
    </fieldset>

    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <div>
      <div class="form-group">
        <label for="inputEmail1">Email address</label>
        <input v-model="form.email" type="email" class="form-control" id="inputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
      </div>
      <div class="form-group">
        <label for="inputPassword1">Password</label>
        <input v-model="form.password" type="password" class="form-control" id="inputPassword1" placeholder="Password">
      </div>
      <router-link :to="{ name: 'forgotPass' }"><small>Forgot Password</small></router-link>
      <div class="m-5">
        <button @click="login" type="submit" class="btn btn-primary btn-outline-white m-1 col-5 ">Login</button>
        <br>
        <br>
        <router-link :to="{ name: 'register' }"><small>Create an Account</small></router-link>
      </div>
      <button class="btn" @click="google">
        <!-- Dark and Light Modes -->
        <img alt=" Sign in with Google" src="../assets/google_signin_buttons/web/1x/btn_google_signin_dark_pressed_web.png"/>
        <!-- <img src="../assets/google_signin_buttons/web/1x/btn_google_signin_light_normal_web.png"/> -->
      </button>
    </div>
  </div>
  <div v-else>
    <dashboard :msg="msg" />
  </div>
</div>
</template>

<script>
import dbservice from '../services/dbservice';
import { mapGetters } from "vuex";
import Dashboard from '../pages/Dashboard'
import { auth } from '../firebase'

export default {
  name: "Login",
  components: {
    Dashboard
  },
  data: () => ({

    form: {
      email: "",
      password: ""
    },
    error: null,
    
    msg: {
      header: "Welcome",
      message: {
        text: `You are Successfully logged in!`,
        color: "success",
      },
      routename: "home",
      routemsg: "Go to Home Page"
    }
    
  }),
  methods: {

    login() {
      dbservice.submitLogin(this.form)
      .catch(err => this.error = err.message)
    },
    google() {
      dbservice.signInWithGoogle()
      .catch(err => this.error = err.message)
    },
  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  }
};
</script>
